import heydoctor from 'app/vendor/heydoctor';
import { Stores, Store } from 'app/lib/synaptik';

interface State {
  submittingNpsScore?: boolean;
  submittingNpsFeedback?: boolean;
}

export class NpsStore extends Store<State, Stores> {
  submitScore = async (score: number, npsMessageId: number) =>
    this.runAsync({
      key: 'submittingNpsScore',
      work: async () => {
        return heydoctor.nps.submitScore(score, npsMessageId);
      },
    });

  submitFeedback = async (response = '', npsMessageId: number) =>
    this.runAsync({
      key: 'submittingNpsFeedback',
      work: async () => {
        const trimmedResponse = response.trim();

        if (trimmedResponse) {
          return heydoctor.nps.submitFeedback(npsMessageId, trimmedResponse);
        }

        return undefined;
      },
    });
}
